import {useSelector} from 'react-redux';
import {getTasks} from 'stores/selectors/cardStateSelector';
import {getLabwareDataById} from 'stores/selectors/labwareStateSelectors';
import PropTypes from 'prop-types';
import {orderBy, pick} from 'lodash';
import {getDeckLabwareRefs} from 'stores/selectors/virtualTraySelectors';
import MixingTask from './Tasks/MixingTask';

function MixingTasksContainer({
  card,
  runtimeMode,
  runtimeStateStatus,
  onArrowDownPress,
  onArrowUpPress,
  onSelectTask,
  getTaskExecutionStatus,
  readOnly,
  onDelete,
  excludedComponentRef,
}) {
  const cardStateTasks = useSelector(getTasks);
  const tasks = Object.values(orderBy(pick(cardStateTasks, card.tasks), ['number'], ['asc']));
  const taskLabware = useSelector(getLabwareDataById(tasks[0]?.labwareID));
  const deckLabwareRefs = useSelector(getDeckLabwareRefs);

  if (!tasks[0]) return null;

  const handleSelectTask = (otherProps = {}) => {
    const {ID, number} = tasks[0];
    const {ID: cardID, type: cardType} = card;

    onSelectTask({taskId: ID, taskNumber: number, cardID, cardType, ...otherProps});
  };

  const handleUnselectTaskAfterEdit = (ID, otherProps) => {
    handleSelectTask(otherProps);
  };

  return (
    <div className="wrapper" onClick={() => handleSelectTask()}>
      <MixingTask
        key={`task-mixing-${card.ID}`}
        number={1}
        task={tasks[0]}
        card={card}
        labware={taskLabware}
        runtimeMode={runtimeMode}
        readOnly={readOnly}
        executionStatus={getTaskExecutionStatus(tasks[0].ID)}
        onSelectTask={handleUnselectTaskAfterEdit}
        onArrowDownPress={onArrowDownPress}
        onArrowUpPress={onArrowUpPress}
        disallowEdit={false}
        runtimeStatus={runtimeStateStatus}
        disableDrag
        onDelete={onDelete}
        excludedComponentRef={[...excludedComponentRef, ...Object.values(deckLabwareRefs ?? {})]}
      />
    </div>
  );
}

MixingTasksContainer.propTypes = {
  card: PropTypes.object.isRequired,
  runtimeMode: PropTypes.bool.isRequired,
  runtimeStateStatus: PropTypes.object,
  onArrowDownPress: PropTypes.func.isRequired,
  onArrowUpPress: PropTypes.func.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  getTaskExecutionStatus: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  excludedComponentRef: PropTypes.array,
};

MixingTasksContainer.defaultProps = {
  runtimeStateStatus: null,
  excludedComponentRef: [],
};

export default MixingTasksContainer;
